module.exports = new __parcel__URL__("requests-deflected.5f7b3322.svg").toString();